import React, { useEffect, useState, useRef } from "react";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import Select from 'react-select';
import axios from 'axios';
import { getUserName, headers } from '../utils/common';
import { env } from './const';
import { Multiselect } from 'multiselect-react-dropdown';
import { getRole } from '../utils/common';
import { Role } from '../utils/role';
import * as axiosInstance from '../utils/axiosinstace';
import { useLoading, Bars } from '@agney/react-loading';
import { useTranslation } from 'react-i18next';
const AddUser = () => {
  const { t } = useTranslation(['user', 'common']);
    // const {register, handleSubmit, errors, control, formState} = useForm ({
    //     mode:'onChange'
    // });
    const { containerProps, indicatorEl } = useLoading({
        loading: true,
        indicator: <Bars width="30" color="#333" />,
      });
      const [formData, setFormData] = useState({});
    const { register, handleSubmit, watch, control, formState: { errors },setValue  } = useForm({
        mode: 'onChange',
        
    });

    const { register: register2, handleSubmit: handleSubmit2, formState: { errors: errors2 } } = useForm({
        mode: 'onChange'
    });
    const [role, setRole] = useState(getRole());
    const [headersobj] = useState(headers());
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [showResults2, setShowResults2] = useState(false)
    const [resultMessage, setResultMessage] = useState({});
    const [showLoader, setShowloader] = useState(false);
    
    const [action, setAction] = useState('Insert');
    const fetchUser = (data, e) => {
        axios.get(env.produrl + '/fetchuser/' + data.userID, { headers: headersobj })
            .then(res => {
                setShowResults2(false);
                console.log(res.data.list)
                setFormData(res.data.list);
                setSelectedFarms(res.data.list.farms);
            }).catch((err) => {
                console.log(err)
                setShowResults2(true)
                // Guarded: a network failure has no err.response at all, so the
                // old form threw a TypeError inside the catch and nothing
                // reached the screen.
                setResultMessage({
                    error: true,
                    message: (err.response && err.response.data && err.response.data.message)
                        || err.message
                        || t('common:state.error')
                });
            });
    }
    const [selectedFarms, setSelectedFarms] = useState([]);
    const onSelect = (selectedList, selectedItem) => {
        setSelectedFarms(selectedList);
        if (selectedFarms.length > 0) {
            setFarmError('')
        }
    }

    const onRemove = (selectedList, removedItem) => {
        setSelectedFarms(selectedList);
        if (selectedFarms.length > 0) {
            setFarmError('')
        }
    }
    const [farmError, setFarmError] = useState('')
    const onSubmit = async(data, e) => {
        e.preventDefault();
        
        //console.log(data);
        data.action = action;
        if (role === Role.Farmer || role === Role.Admin) {
            data.farms = selectedFarms;
        } else {
            data.farms = [];
        }
        data.farms = selectedFarms;
        if (data.roleID === Role.Worker || role === Role.Farmer) {
            if (selectedFarms.length === 0) {
                setFarmError(t('user:validation.atLeastOneFarm'));
                return;
            } else {
                setFarmError('');
            }
        }
        data.barnSensors = true;

        // The Password input unmounts when the role changes, but react-hook-form
        // v7 defaults to shouldUnregister:false and keeps the last value it held.
        // Sending it is merely pointless on Insert (the API ignores a password
        // for these roles) but actively destructive on Update, where a stale
        // string would be hashed and stored over the real credential.
        if (isInvitedRole) delete data.password;
        // alert(JSON.stringify(data))
        try {
            setShowloader(true);
        //     alert(JSON.stringify(data))
        // return;
            const response = await axiosInstance.addUser(data);
                // console.log(res.data.message);
                setShowResults(true);
                setShowloader(false);
                
                if(response.status) {
                    setFormData({});
                    setSelectedFarms([]);
                    setFarmers([]);
                    setFarms([]);
                    e.target.reset();
                    document.getElementById("userID").removeAttribute("readonly", "readonly");
                    setResultMessage({
                        error: false, message: response.message
                    });
                    fetchFarms.current(getUserName());
                } else {
                    setResultMessage({
                        error: true, message: response.message
                    });
                }
                
        } catch (err) {
            setShowResults(true);
            setResultMessage({
                error: true,
                message: (err.response && err.response.data && err.response.data.message)
                    || err.message
                    || t('common:state.error')
            });
            setShowloader(false);
        }
        // axios.post(env.produrl + '/addUser', data, { headers: headersobj })
        //     .then(res => {
        //         // console.log(res.data.message);
        //         setShowResults(true);
        //         setResultMessage({
        //             error: false, message: res.data.message
        //         });
        //         setFormData({});
        //         setSelectedFarms([]);
        //         setFarmers([]);
        //         setFarms([]);
        //         e.target.reset();
        //         document.getElementById("userID").removeAttribute("readonly", "readonly");
        //         fetchFarms.current(getUserName());
        //     }).catch((err) => {
        //         console.log(err)
        //         setShowResults(true)
        //         setResultMessage({
        //             error: true, message: err.response.data.message
        //         });
        //         console.log(err.response.data.message);
        //     });
    }

    const onCountrychange = (e, countryID) => {
        let _id = '';
        if (e === undefined || e === null || e === '') {
            _id = countryID;
        } else {
            _id = e.target.value;
        }
        axios.get(env.produrl + '/geoLocations/states/' + _id
        ).then(res => {
            setStates(res.data.list)

        }).catch((err) => {
            console.log(err);
        });
    }
    const onStatechange = (e, stateID) => {
        let _id = '';
        if (e === undefined || e === null || e === '') {
            _id = stateID;
        } else {
            _id = e.target.value;
        }

        axios.get(env.produrl + '/geoLocations/cities/' + _id
        ).then(res => {
            setCities(res.data.list)

        }).catch((err) => {
            console.log(err);
        });
    }
    const [farms, setFarms] = useState([]);
    const [roles, setRoles] = useState([]);
    const [farmers, setFarmers] = useState([]);
    const fetchFarms = useRef()
    // Called three ways, all of which have to keep working:
    //   ''            -> Update-mode prefill; use the row we just fetched
    //   a DOM event   -> the native selects elsewhere on this form
    //   a userName    -> the react-select farmer picker below
    const onFarmerChange = (e) => {
        let selectedFarmer = '';
        if (e === '') {
            selectedFarmer = formData.farmowner;
        } else if (e && e.target) {
            selectedFarmer = e.target.value;
        } else {
            selectedFarmer = e || '';
        }
        fetchFarms.current(selectedFarmer);
    }
    const[_selectedRole , setSelectedRole] = useState('');
    const onRolechange = (e) => {
        setShowResults(false);
        // Update mode calls this as onRolechange('') once /fetchuser resolves.
        // setSelectedRole used to be called ONLY in the else branch, so
        // _selectedRole stayed '' for every edit and anything keyed on the role
        // being edited silently took the "nothing selected" path.
        // String(): the API returns roleID as a number, Role.* are strings.
        const selectedRole = e === ''
            ? String(formData.roleID == null ? '' : formData.roleID)
            : String(e.target.value);
        setSelectedRole(selectedRole);
        if (selectedRole === Role.Worker || selectedRole === Role.Digiviewer) {
            axios.get(env.produrl + '/misc/listoffarmers', { headers: headersobj })
                .then(res => {
                    //alert(res.data.list)
                    setFarmers(res.data.list);
                    console.log(res.data.list)
                }).catch((err) => {
                    setFarmers([])
                    console.log(err.message);
                });
        } else {
            setFarmers([]);
        }
    }
    fetchFarms.current = (famerUserName) => {

        axios.get(env.produrl + '/misc/listoffarms/' + famerUserName, { headers: headersobj })
            .then(res => {
                let farmDropDown = [];
                res.data.list.forEach((item) => {
                    farmDropDown.push({
                        name: item.farmName,
                        id: item.farmID
                    })
                })
                setFarms(farmDropDown)
            }).catch((err) => {
                console.log(err.message);
            });
    }
    useEffect(() => {
        axios.get(env.produrl + '/geoLocations/countries')
            .then(res => {
                setCountries(res.data.list)
            }).catch((err) => {
                console.log(err.message);
            });
        if (role === Role.Admin) {
            axios.get(env.produrl + '/misc/roles', { headers: headersobj })
                .then(res => {
                    setRoles(res.data.list)
                }).catch((err) => {
                    setRoles([]);
                    console.log(err.message);
                });
        }
        if (role === Role.Farmer) {
            fetchFarms.current(getUserName());
        }

        if (Object.keys(formData).length > 0) {
            let e = ""
            onCountrychange(e, formData.country);
            onStatechange(e, formData.state);
            onRolechange(e);
            onFarmerChange(e);
            //onFarmerChange(e, "hhh")
            setAction('Update');
            document.getElementById("userID").setAttribute("readonly", "readonly");

            setValue('farmer', formData.farmowner || '')
            setValue('name', formData.farmerName)
            setValue('userName', formData.userName)
            setValue('orgName', formData.org)
            setValue('emailID', formData.emailID)
            setValue('phoneNumber', formData.phoneNumber)
            setValue('addressLine1', formData.addressLine1)
            setValue('addressLine2', formData.addressLine2)
            setValue('country', formData.country)
            setValue('state', formData.state);
            setValue('city', formData.city);
            setValue('status', formData.status);
            setValue('waterMeter', formData.watermeter==0?false:true);
            setValue('controls', formData.controls==0?false:true);
            setValue('role', formData.roleID)
        }
    }, [formData, fetchFarms]);
    //  const [optionsArray] = useState( [
    //     { key: "au", label: "Australia" },
    //     { key: "ca", label: "Canada" },
    //     { key: "us", label: "USA" },
    //     { key: "pl", label: "Poland" },
    //     { key: "es", label: "Spain" },
    //     { key: "fr", label: "France" },
    //   ]);

    // Which control occupies the second slot of the credentials row, keyed on
    // the role being CREATED rather than on farmers.length.
    //
    // farmers is a side effect of GET /misc/listoffarmers, which onRolechange
    // fires only for Worker/Viewer. Using its length as the signal meant that if
    // that request failed or came back empty, setFarmers([]) ran and the form
    // silently swapped to Organization Name -- creating an account with no
    // password field at all, and no way for its owner ever to sign in.
    //
    //   'password' -- Worker only. routes/addUsers.js hashes a typed password
    //                 for roleID 3 and no other, so it is the only role where
    //                 asking for one is honest.
    //   'invite'   -- Viewer. Sets its own password from an emailed link.
    //   'org'      -- Admin creating a Farmer or another Admin.
    const credentialField =
          role !== Role.Admin               ? 'password'   // Farmer creating a Worker
        : _selectedRole === Role.Worker     ? 'password'
        : _selectedRole === Role.Digiviewer ? 'invite'
        :                                     'org';

    // Searchable farmer picker. There can be ~90 farmers, so a native <select>
    // means scrolling a long unsorted list; react-select gives typeahead. Same
    // component and sizing as the farmer filter on the Users list, so the two
    // pickers behave identically.
    const farmerOptions = farmers.map((f) => ({
      value: f.userName,
      label: f.farmerName || f.userName,
    }));
    // Sized to sit level with the .form-control-sm inputs beside it.
    const farmerSelectStyles = {
      control: (base) => ({ ...base, minHeight: 31, height: 31, fontSize: 13, borderColor: '#ddd' }),
      valueContainer: (base) => ({ ...base, padding: '0 8px' }),
      input: (base) => ({ ...base, margin: 0, padding: 0 }),
      indicatorsContainer: (base) => ({ ...base, height: 31 }),
      dropdownIndicator: (base) => ({ ...base, padding: 4 }),
      clearIndicator: (base) => ({ ...base, padding: 4 }),
      option: (base) => ({ ...base, fontSize: 13, padding: '6px 10px' }),
      // Portalled so the menu is never clipped by the card it sits in.
      menuPortal: (base) => ({ ...base, zIndex: 1060 }),
    };

    // Roles the server emails a set-password invite to. Email is mandatory for
    // these -- an invite with no address goes nowhere and the account is stranded.
    const isInvitedRole =
        _selectedRole === Role.Farmer || _selectedRole === Role.Digiviewer;

    return (
        <div className="batchOperations">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h2 class="m-0 text-dark">{t('user:add.title')}</h2>
                </div>
            </div>
            <div className="col-12">
                <div className="card collapsed-card">
                    <div className="card-header">
                        <p className="card-title font12">{t('user:add.fetchHint')}</p>
                        <div className="card-tools">
                            <button type="button" className="btn btn-tool" data-card-widget="collapse">
                                <i className="fas fa-plus" />
                            </button>
                        </div>
                    </div>
                    <div className="card-body p-10" style={{ display: 'none' }}>
                        <form onSubmit={handleSubmit2(fetchUser)}>
                            <div>
                                {showResults2 ? <Results key={Math.random()} message={resultMessage.message} error={resultMessage.error2} /> : null}
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label htmlFor>{t('user:add.userOrPhone')}</label>
                                        <input type="text" className="form-control form-control-sm" id placeholder={t('user:add.enterUserOrPhone')}
                                            name="userID"  {...register2('userID',
                                                {
                                                    required: t('forms:requiredField.userOrPhone')
                                                }
                                            )} />
                                        {errors2.userID && <span className="err-msg">{errors2.userID.message}</span>}
                                    </div>
                                </div>
                                <div className="col-md-4 mt10">
                                    <div class="form-group">

                                        <button type="submit" value="Submit" class="btn btn-sm btn-secondary">{t('common:actions.fetch')}</button>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
                <div className="card">
                    <div class="card-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                           
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label htmlFor>{t('common:fields.name')}</label>
                                        <input type="text" className="form-control form-control-sm" id placeholder={t('user:add.enterName')}
                                            name="name" defaultValue={Object.keys(formData).length > 0 ? formData.farmerName : ""} {...register('name',
                                                {
                                                    required: t('forms:requiredField.name'),
                                                    minLength: { value: 3, message: t('common:validation.nameTooShort') },
                                                    maxLength: { value: 50, message: t('common:validation.nameTooLong') }
                                                }
                                            )} />
                                        {errors.name && <span className="err-msg">{errors.name.message}</span>}
                                    </div>
                                </div>
                                {role === Role.Admin ?
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>{t('common:select.role')}</label>
                                            <select class="form-control form-control-sm" name="role"
                                                {...register('role', {
                                                    required: t('forms:select.role'),
                                                    
                                                })}
                                                onChange={onRolechange}
                                            >
                                                <option value="">{t('common:select.dashed')}</option>
                                                {roles.map(item => (
                                                    <option
                                                        key={item.roleID}
                                                        value={item.roleID}
                                                        selected={formData.roleID === "" + item.roleID ? true : false}
                                                    >
                                                        {item.roleName}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.role && <span className="err-msg">{errors.role.message}</span>}
                                        </div>
                                    </div>
                                    : ""}

                                {farmers.length > 0 ?

                                    <div className="col-md-4">

                                        <div className="form-group">
                                            <label>{t('common:select.farmer')} </label>
                                            {/* <DropdownMultiselect options={optionsArray} name="countries" /> */}
                                            {/* Controller, not register(): react-select is not a
                                                native input, so RHF cannot bind it by ref. */}
                                            <Controller
                                                name="farmer"
                                                control={control}
                                                rules={{ required: t('forms:select.farmer') }}
                                                render={({ field }) => (
                                                    <Select
                                                        inputId="addUserFarmer"
                                                        aria-label={t('common:select.farmer')}
                                                        options={farmerOptions}
                                                        value={farmerOptions.find((o) => o.value === field.value) || null}
                                                        onChange={(opt) => {
                                                            const userName = opt ? opt.value : '';
                                                            field.onChange(userName);
                                                            // Reload the farms multiselect for the new owner.
                                                            onFarmerChange(userName);
                                                        }}
                                                        onBlur={field.onBlur}
                                                        placeholder={t('common:select.dashed')}
                                                        isClearable
                                                        isSearchable
                                                        styles={farmerSelectStyles}
                                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                        noOptionsMessage={() => t('common:state.noDataFound')}
                                                    />
                                                )}
                                            />
                                            {errors.farmer && <span className="err-msg">{errors.farmer.message}</span>}
                                        </div>
                                    </div>
                                    : ""}
                            </div>
                            {role === Role.Farmer || farmers.length > 0 ?
                                <div className="row">
                                    <div className="col-md-4">
                                        <div class="form-group">
                                            <label htmlFor>{t('common:select.farms')}</label>
                                            <Multiselect
                                                options={farms} // Options to display in the dropdown
                                                selectedValues={selectedFarms} // Preselected value to persist in dropdown
                                                onSelect={onSelect} // Function will trigger on select event
                                                onRemove={onRemove} // Function will trigger on remove event
                                                displayValue="name" // Property name to display in the dropdown options
                                                //className='form-control form-control-sm'
                                                name="farms"
                                        
                                            />
                                            {<span className="err-msg">{farmError}</span>}
                                        </div>
                                    </div>
                                </div>
                                : ""}
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label htmlFor>{t('common:fields.userName')}</label>
                                        <input type="text"
                                            defaultValue={Object.keys(formData).length > 0 ? formData.userName : ""}
                                            className="form-control form-control-sm" placeholder={t('user:add.enterUserName')}
                                            name="userName" id="userID"
                                            {...register('userName',
                                                {
                                                    required: t('forms:requiredField.userName'),
                                                    minLength: { value: 3, message: t('user:validation.userNameTooShort') },
                                                    maxLength: { value: 20, message: t('user:validation.userNameTooLong') },
                                                    pattern: { value: /[^ ]+$/i, message: t('user:validation.noSpaces') }
                                                }
                                            )} />
                                        {errors.userName && <span className="err-msg">{errors.userName.message}</span>}
                                    </div>
                                </div>
                                
                                {credentialField === 'org' ?
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label htmlFor>{t('common:fields.organizationName')}</label>
                                            <input type="text" className="form-control form-control-sm" placeholder={t('user:add.enterOrganizationName')}
                                                name="orgName" defaultValue={Object.keys(formData).length > 0 ? formData.org : ""}
                                                {...register('orgName',
                                                    {
                                                        //required: t('forms:requiredField.organization'),
                                                        minLength: { value: 3, message: t('user:validation.orgTooShort') },
                                                        maxLength: { value: 50, message: t('user:validation.orgTooLong') }
                                                    }
                                                )} />
                                            {errors.orgName && <span className="err-msg">{errors.orgName.message}</span>}
                                        </div>
                                    </div>
                                : credentialField === 'password' ?
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label htmlFor>{t('common:fields.password')}</label>
                                        <input type="password" className="form-control form-control-sm" placeholder={t('user:add.enterPassword')}
                                            name="password" defaultValue={Object.keys(formData).length > 0 ? "defaultPassword" : ""}
                                            {...register('password',
                                                {
                                                    required: t('forms:requiredField.password'),
                                                    minLength: { value: 5, message: t('user:validation.passwordTooShort') }
                                                }
                                            )} />
                                        {errors.password && <span className="err-msg">{errors.password.message}</span>}
                                    </div>
                                </div>
                                :
                                // credentialField === 'invite' (Viewer): no password
                                // control at all. The explanation sits under the Email
                                // field instead, next to the address it depends on.
                                null
                                }
                            </div>
                            <div className="row">
                                {
                                    role == Role.Admin?
                                
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor>{t('common:fields.email')}</label>
                                        <input type="text"
                                            defaultValue={Object.keys(formData).length > 0 ? formData.emailID : ""}
                                            className="form-control form-control-sm" id placeholder={t('user:add.enterEmail')}
                                            name="emailID" {...register('emailID',
                                                {
                                                  // Required for every role the server emails an invite to --
                                                  // Farmer and now Viewer. Without an address the account is
                                                  // created and then stranded, with no way to set a password.
                                                  required: isInvitedRole ? t('forms:requiredField.email') : false,
                                                  pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,  message: t('user:validation.invalidEmail')}
                                                }
                                            )} />
                                        {errors.emailID && <span className="err-msg">{errors.emailID.message}</span>}
                                        {isInvitedRole && !errors.emailID && (
                                            // .fieldHint, not .notEntered: the latter is an uppercase
                                            // pink badge for two-word states, and rendered this whole
                                            // sentence as a shouty pill.
                                            <span className="fieldHint">
                                                {action === 'Insert'
                                                    ? t('user:add.inviteHint')
                                                    : t('user:add.inviteResendHint')}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                :
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor>{t('common:fields.email')}</label>
                                        <input type="text"
                                            defaultValue={Object.keys(formData).length > 0 ? formData.emailID : ""}
                                            className="form-control form-control-sm" id placeholder={t('user:add.enterEmail')}
                                            name="emailID" {...register('emailID',
                                                {
                                                  // No `required` rule here on purpose. This branch is what a
                                                  // FARMER sees while creating a Worker, and a Worker never
                                                  // gets an invite -- it is given a password directly. There is
                                                  // also no role select on this branch, so _selectedRole is
                                                  // permanently '' and an isInvitedRole test could never fire.
                                                  // Pattern unified with the admin variant above, which the old
                                                  // one rejected addresses like ali.k@farm.com.
                                                  pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: t('user:validation.invalidEmail')}
                                                }
                                            )} />
                                        {errors.emailID && <span className="err-msg">{errors.emailID.message}</span>}
                                    </div>
                                </div>
                                }
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor>{t('common:fields.phoneNumber')}</label>
                                        <input type="text"
                                            defaultValue={Object.keys(formData).length > 0 ? formData.phoneNumber : ""}
                                            className="form-control form-control-sm" id placeholder={t('user:add.enterPhone')}
                                            name="phoneNumber" {...register('phoneNumber',
                                                {
                                                    required: _selectedRole==Role.Farmer?t('forms:requiredField.phone'):false,
                                                    pattern: { value: /^[0-9]+$/i, message: t('user:validation.invalidPhone') },
                                                    minLength: { value: 10, message: t('user:validation.invalidPhone') },
                                                    maxLength: { value: 11, message: t('user:validation.invalidPhone') }
                                                }
                                            )} />
                                        {errors.phoneNumber && <span className="err-msg">{errors.phoneNumber.message}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor>{t('common:fields.addressLine1')}</label>
                                        <input type="text"
                                            defaultValue={Object.keys(formData).length > 0 ? formData.addressLine1 : ""}
                                            className="form-control form-control-sm" id placeholder={t('user:add.enterAddress1')}
                                            name="addressLine1" {...register('addressLine1',
                                                {
                                                    required: _selectedRole==Role.Farmer?t('forms:requiredField.address1'):false,
                                                    minLength: { value: 5, message: t('common:validation.min5Chars') },
                                                    maxLength: { value: 100, message: t('common:validation.max30Chars') }
                                                }
                                            )} />
                                        {errors.addressLine1 && <span className="err-msg">{errors.addressLine1.message}</span>}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor>{t('common:fields.addressLine2')}</label>

                                        <input type="text"
                                            defaultValue={Object.keys(formData).length > 0 ? formData.addressLine2 : ""}
                                            className="form-control form-control-sm" id placeholder={t('user:add.enterAddress2')}
                                            name="addressLine2" {...register('addressLine2',
                                                {
                                                    //required: t('forms:requiredField.address2'),
                                                    minLength: { value: 5, message: t('common:validation.min5Chars') },
                                                    maxLength: { value: 100, message: t('common:validation.max30Chars') }
                                                }
                                            )} />
                                        {errors.addressLine2 && <span className="err-msg">{errors.addressLine2.message}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor>{t('common:fields.country')}</label>
                                        <select name="country"
                                            defaultValue={Object.keys(formData).length > 0 ? formData.country : ""}
                                            id="country" className="form-control form-control-sm"
                                            {...register('country',
                                                {
                                                    required: _selectedRole==Role.Farmer?t('forms:requiredField.country'):false,
                                                    onChange: (e) => { onCountrychange(e) }
                                                }
                                            )}
                                        >
                                            <option value="">{t('common:select.dashed')}</option>
                                            {countries.map(item => (
                                                <option
                                                    key={item.id}
                                                    value={item.id}
                                                    selected={formData.country === "" + item.id ? true : false}
                                                >
                                                    {item.name}
                                                </option>

                                            ))}
                                        </select>
                                        {errors.country && <span className="err-msg">{errors.country.message}</span>}
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor>{t('common:fields.state')}</label>
                                        <select name="state" className="form-control form-control-sm"
                                            {...register('state',
                                                {
                                                    required: _selectedRole==Role.Farmer?t('forms:requiredField.state'):false,
                                                    onChange: (e) => { onStatechange(e) }
                                                }
                                            )}
                                        >
                                            <option value="">{t('common:select.dashed')}</option>
                                            {states.map(item => (
                                                <option
                                                    key={item.id}
                                                    value={item.id}
                                                    selected={formData.state === "" + item.id ? true : false}
                                                >
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.state && <span className="err-msg">{errors.state.message}</span>}
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor>{t('common:fields.city')}</label>
                                        <input type="text"
                                            defaultValue={Object.keys(formData).length > 0 ? formData.city : ""}
                                            className="form-control form-control-sm" id placeholder={t('user:add.enterCity')}
                                            name="city" {...register('city',
                                                {
                                                    //required: t('forms:requiredField.city')
                                                    required: _selectedRole==Role.Farmer?t('forms:requiredField.city'):false,

                                                }
                                            )} />

                                        {errors.city && <span className="err-msg">{errors.city.message}</span>}
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor>{t('common:fields.status')}</label>

                                        <select name="status" className="form-control form-control-sm"

                                            {...register('status',
                                                {
                                                    required: t('forms:requiredField.status')
                                                }
                                            )}
                                        >
                                            {/* <option value="">{t('common:select.dashed')}</option> */}
                                            <option value="ACTIVE" selected={formData.status === "ACTIVE" ? true : false}>ACTIVE</option>
                                            <option value="INACTIVE" selected={formData.status === "INACTIVE" ? true : false}>INACTIVE</option>

                                        </select>
                                        {errors.status && <span className="err-msg">{errors.status.message}</span>}
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            {
                                role == Role.Admin && _selectedRole === Role.Farmer?
                            
                            <div className="row">
                                <div className="col-md-8">
                                    <p>{t('user:add.chooseIotSensors')}</p>
                                    <div class="form-group">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" disabled checked='true'
                                                            {...register('barnSensors')}
                                                    />
                                                    <label class="form-check-label">{t('user:add.barnSensesDefault')}</label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" 
                                                            {...register('waterMeter')}
                                                           
                                                    />
                                                    <label class="form-check-label">{t('user:add.waterMeter')}</label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox"
                                                        {...register('controls')}
                                                    />
                                                    <label class="form-check-label">{t('user:add.controlSystems')}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :<></>}
                            <div className='row'>
                                <div className="col-md-1">
                                    <div class="form-group">
                                        <input type="submit" value={t('common:actions.submit')} class="btn btn-primary" />
                                    </div>
                                    
                                </div>
                                <div className='col-md-1'>
                                        { showLoader?
                                            <section {...containerProps} style = {{"margin-top": "0px", color: '#ccc'}}>
                                                {indicatorEl} 
                                            </section> :""
                                        }
                                    </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    {showResults ? <Results key={Math.random()} message={resultMessage.message} error={resultMessage.error} /> : null}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* <ErrorModal key= {Math.random()} onChange={handleChange} estatus={errorModal.estatus} show={errorModal.show} message={errorModal.message}></ErrorModal> */}
        </div>
    );
}
const Results = (props) => {
    // Module-level component, so it cannot borrow AddUser's `t` -- it needs its
    // own hook. These two words were the last untranslated strings on the page.
    const { t } = useTranslation(['common']);
    let error, classes;
    if (props.error === false) {
        error = t('common:state.success');
        classes = 'alert alert-success alert-dismissible fade show'
    } else {
        error = t('common:state.error');
        classes = 'alert alert-danger alert-dismissible fade show'
    }
    return (
        <div className="results">
            <div className={classes}>
                <strong>{error}</strong> {props.message}

                <button type="button" class="close" data-dismiss="alert">&times;</button>
            </div>
        </div>
    );
}
export default AddUser;